import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";

export class ColumnDeleteIcon extends ColumnBase {

    public getContent(row: any): HTMLElement {
        return <i className="fal fa-trash"></i>;
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        const cell = super.createCell(rowModel, idField);
        cell.classList.add("mt-delete-icon");
        cell.classList.add("pointer");
        cell.setAttribute("data-id", rowModel[idField]);
        cell.addEventListener("click", this.onDeleteIconClicked);
        return cell;
    }

    onDeleteIconClicked = (ev: MouseEvent) => {
        if (this.table.props.onDeleteIconClicked) {
            this.table.props.onDeleteIconClicked((ev.currentTarget as HTMLElement).getAttribute("data-id"));
            ev.stopPropagation();
        }
    }

    public hideContent(cell: HTMLElement): void {
        cell.classList.remove("pointer");
        cell.removeEventListener("click", this.onDeleteIconClicked);
        cell.firstElementChild.classList.add("d-none");
    }
}